module.exports = __webpack_public_path__ + "static/media/phong-an.f4ff3ca4.gif";